declare var window: any
const message = (text: string) => {
  const tips = document.getElementById('tips');
  if (tips) {
    tips.remove();
  }

  const template = `<div class="toolTips"  id='tips'> ${text} </div>`
  let tempNode = document.createElement('div');
  tempNode.innerHTML = template;
  const app = document.getElementById('root');
  if (app)
    app.appendChild(tempNode);
  setTimeout(() => {
    tempNode.remove();
  }, 1500)
}

const getParameterByName = (name: string) => {
  name = name.replace(/[\\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  const results = regex.exec(window.location.href);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const convertBase64ToBlob = (base64: any) => {
  var base64Arr = base64.split(',');
  var imgtype = '';
  var base64String = '';
  if (base64Arr.length > 1) {
    //如果是图片base64，去掉头信息
    base64String = base64Arr[1];
    imgtype = base64Arr[0].substring(base64Arr[0].indexOf(':') + 1, base64Arr[0].indexOf(';'));
  }
  // 将base64解码
  var bytes = atob(base64String);
  //var bytes = base64;
  var bytesCode = new ArrayBuffer(bytes.length);
  // 转换为类型化数组
  var byteArray = new Uint8Array(bytesCode);

  // 将base64转换为ascii码
  for (var i = 0; i < bytes.length; i++) {
    byteArray[i] = bytes.charCodeAt(i);
  }

  // 生成Blob对象（文件对象）
  return new Blob([bytesCode], { type: imgtype });
};

const random_string = (len: any) => {
  len = len || 32;
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  const maxPos = chars.length;
  let pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

// const getParameterByName =  (name:any)=> {
//   name = name.replace(/[\\[]/, '\\[').replace(/[\]]/, '\\]');
//   const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
//   const results = regex.exec(location.href);
//   return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
// };

/**
 * 分钟数转成小时表示
 * @param number
 * @returns {string}
 */
const intToHours = (number: any) => {
  //如果的整数
  let hours: any;
  let minutes: any;
  if (number % 1 === 0) {
    hours = Math.floor(number / 60);
    minutes = number % 60;
  }
  hours = hours < 10 ? '0'.concat(hours) : hours;
  minutes = minutes < 10 ? '0'.concat(minutes) : minutes;
  return hours + ':' + minutes;
}

const formatDate = (format: any, timestamp: any) => {
  if (!timestamp) return ''
  if (timestamp === 0) return ''

  const date = new Date(parseInt(timestamp))
  let y = date.getFullYear(),
    m: any = date.getMonth() + 1,
    d: any = date.getDate(),
    h: any = date.getHours(),
    i: any = date.getMinutes(),
    s: any = date.getSeconds(),
    w = date.getDay(),
    week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

  m = m < 10 ? '0' + m : m
  d = d < 10 ? '0' + d : d
  h = h < 10 ? '0' + h : h
  i = i < 10 ? '0' + i : i
  s = s < 10 ? '0' + s : s
  return format
    .replace('YYYY', y)
    .replace('MM', m)
    .replace('DD', d)
    .replace('H', h)
    .replace('i', i)
    .replace('s', s)
    .replace('WW', week[w])
}

const formatTime = (format: any, timestamp: any) => {
  if (!timestamp) {
    return
  }
  const date = new Date(parseInt(timestamp))
  let y = date.getFullYear(),
    m = date.getMonth() + 1,
    d = date.getDate(),
    h = date.getHours() - 8,
    i = date.getMinutes(),
    s = date.getSeconds()
  return format
    .replace('YYYY', y)
    .replace('MM', m)
    .replace('DD', d)
    .replace('H', h)
    .replace('i', i)
    .replace('s', s)
}

/**
 * 获取当前开发环境
 */
const getEnvValue = () => {
  let env = 'dev';
  switch (process.env.DEPLOY_ENV) {
    case 'dev':
    case 'rc':
      env = process.env.DEPLOY_ENV;
      break;
    case 'gray':
    case 'prod':
      env = 'b';
      break;
    default:
      break;
  }
  return env;
}

export {
  message,
  getParameterByName,
  convertBase64ToBlob,
  random_string,
  intToHours,
  formatDate,
  formatTime,
  getEnvValue
}